import { MaterialCommunityIcons } from '@expo/vector-icons';
import * as Google from 'expo-auth-session/providers/google';
import * as WebBrowser from 'expo-web-browser';
import React, { useEffect } from 'react';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import { APP_NAME, TOKEN_GOOGLE_ANDROID, TOKEN_GOOGLE_WEB } from '../../shared/constants';
import Button from '../Generic/Button';

WebBrowser.maybeCompleteAuthSession();

export default function GoogleLogin() {
  const [sessao, login, logout, revalidate, loginGoogle] = useSessao();

  const [request, response, promptAsync] = Google.useAuthRequest(
    {
      // iosClientId: '',
      expoClientId: TOKEN_GOOGLE_WEB,
      webClientId: TOKEN_GOOGLE_WEB,
      androidClientId: TOKEN_GOOGLE_ANDROID
    },
    {
      path: `/${APP_NAME}`,
      projectNameForProxy: `@silventino/${APP_NAME}`
    }
  );

  const fazerLogin = async (tokenGoogle: string) => {
    try {
      await loginGoogle(tokenGoogle);
    } catch (err) {
      console.log(err);
      // Alert.alert('Erro ao fazer login com o Google.');
    }
  };

  useEffect(() => {
    // Alert.alert(`Mudou response! : ${response?.type}`);
    if (response?.type === 'success') {
      const { authentication } = response;
      fazerLogin(authentication.accessToken);
    }
  }, [response]);

  return (
    <Button
      title={'Entrar com Google'}
      onPress={() => promptAsync()}
      style={{ marginTop: 20, maxWidth: 210, alignSelf: 'center' }}
      icon={
        <MaterialCommunityIcons name="google" size={24} color="white" style={{ marginRight: 5 }} />
      }
    />
  );
}
